import type { RefObject } from "react";
import { Dialog, Popover } from "react-aria-components";

import callCenterIcon from "@/assets/figma/customer-service/call-center.svg";
import customerServiceImage from "@/assets/figma/customer-service/customer-service-qr.jpg";
import auroraOverlay from "@/assets/figma/home/aurora-overlay.png";

interface MerryCustomerServicePopoverProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  triggerRef: RefObject<HTMLButtonElement | null>;
}

export function MerryCustomerServicePopover({
  isOpen,
  onOpenChange,
  triggerRef,
}: MerryCustomerServicePopoverProps) {
  return (
    <Popover
      className="merry-customer-service-popover"
      containerPadding={12}
      isOpen={isOpen}
      offset={0}
      onOpenChange={onOpenChange}
      placement="bottom"
      shouldCloseOnInteractOutside={(element) =>
        !triggerRef.current?.contains(element)
      }
      shouldFlip
      triggerRef={triggerRef}
    >
      <Dialog
        aria-label="Merry 客服二维码"
        className="merry-customer-service-popover__dialog"
      >
        <section
          className="merry-customer-service-popover__panel"
          data-figma-node-id="821:107253"
          data-testid="customer-service-popover"
        >
          <header className="merry-customer-service-popover__header">
            <span
              aria-hidden="true"
              className="merry-customer-service-popover__identity-icon"
            >
              <img
                alt=""
                className="merry-customer-service-popover__identity-surface"
                src={auroraOverlay}
              />
              <img
                alt=""
                className="merry-customer-service-popover__identity-glyph"
                src={callCenterIcon}
              />
            </span>

            <span className="merry-customer-service-popover__copy">
              <strong>Merry 客服</strong>
              <span>10:00-23:00 (UTC+8)</span>
            </span>

          </header>

          <div className="merry-customer-service-popover__body">
            <div className="merry-customer-service-popover__qr-surface">
              <div className="merry-customer-service-popover__qr-viewport">
                <img
                  alt="Merry 客服微信二维码"
                  className="merry-customer-service-popover__qr-image"
                  src={customerServiceImage}
                />
              </div>
            </div>
          </div>
        </section>
      </Dialog>
    </Popover>
  );
}
